<template>
  <div class="active-bag">
    <div class="yuanhongbao">
      <img
        src="../../../assets/active/zhuangshi@3x.png"
        alt=""
        class="zhuangshi"
      />
      <div class="active-bag-title">
        <span>众智云擎</span><br />
        <span>给您发了一个红包</span>
      </div>
      <div class="anjianbox">
        <div class="anjian" @click="handler"></div>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  components: {},
  data() {
    return {};
  },
  created() {
    console.log(this.$route.query);
  },
  methods: {
    handler() {
      this.$emit("handler");
    },
  },
};
</script>
<style lang="less" scope>
.active-bag {
  width: 100%;

  .yuanhongbao {
    position: relative;
    margin-left: 50%;
    transform: translateX(-50%);
    width: 294px;
    height: 434px;
    background: url(../../../assets/active/yuanhongbao@3x.png) no-repeat;
    background-size: contain;
    .zhuangshi {
      position: absolute;
      top: -40px;
      left: 50%;
      transform: translateX(-50%);
      width: 374px;
      height: 366px;
    }
    .active-bag-title {
      position: absolute;
      top: 80px;
      width: 100%;
      font-size: 20px;
      text-align: center;
      color: #fde6b5;
    }
    .anjianbox {
      position: absolute;
      top: 200px;
      left: 50%;
      width: 84px;
      height: 84px;
      transform: translateX(-50%);
    }
    .anjian {
      position: absolute;
      width: 100%;
      height: 100%;
      background: url(../../../assets/active/anjian@3x.png) no-repeat;
      background-size: contain;
      animation: active 0.5s infinite cubic-bezier(0, 0.08, 0, 0.94);
      box-shadow: rgba(171, 11, 9, 0.6) 0 0 10px;
      border-radius: 50%;
    }
  }
}
</style>
